import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  setAddGroup,
  setClientDataAction,
  setGroupDetailsAndParticptionDates,
  setGroupTabDataAction,
} from '../../../group/store/group-action';
import { redirectURLLink } from '../../../../../SharedModules/CommonUtilities/commonUtilities';

const MaintainClientCustomNaviation = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const goToGroup = (obj) => {
    const { clientId } = obj;
    const { groupId } = obj;

    dispatch(setAddGroup(false));
    dispatch(setGroupDetailsAndParticptionDates(groupId, clientId, true));
    dispatch(
      setGroupTabDataAction({ tabValue: 'one', disableSaveAndCancel: false })
    );
    redirectURLLink('/group-maintain', 'Maintain Group', history, dispatch);
  };

  return (
    <div>
      <span
        style={{
          cursor: 'pointer',
          color: 'blue',
          textDecoration: 'underline',
        }}
        onClick={() => {
          if (props.column.colId === 'groupId') {
            const obj = {
              clientId: props.data.clientId,
              groupId: props.data.groupId,
            };
            goToGroup(obj);
          }
        }}
      >
        {props.column.colId === 'groupId'
          ? props.data && props.data.groupId && props.data.groupId
          : 'Client'}
      </span>
    </div>
  );
};

export default MaintainClientCustomNaviation;
